
import './index.scss';
import QuestionComment from '../question_comment';
import { EventManager } from 'utils/event_manager';

export default class QuestionCommentEditor {
  constructor(context) {
    vendorManager.ensure('quill', () => {
      this.$context = $(context);
      this.questionId = this.$context.data().questionId;
      this.replyEnabled = this.$context.data().replyEnabled;
      this.maximumCharactersLength = this.$context.data().maximumCharactersLength;
      this.$cancelButton = $('.js-cancel-comment-btn', this.$context);
      this.$sendButton = $('.js-send-comment-btn', this.$context);
      this.$questionCommentArea = false;
      this.progressCircle = $('.js-progress-circle', this.context).get(0);
      this.charCounter = $('.js-char-counter', this.context).get(0);

      this.instantiateQuill();
    });
  }

  instantiateQuill() {
    const $editor = $(`#editor-target-${this.questionId}`, this.$context);

    // if quill was already started here we can skip the init function
    if (!$editor.length || $editor.hasClass('ql-container')) {
      return;
    }

    this.editor = new Quill($editor.get(0), {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ color: [true, 'red', 'green', 'blue'] }],
          [{ list: 'ordered' }, { list: 'bullet' }]
        ]
      },
      placeholder: 'Escreva o seu comentário',
      theme: 'snow'
    });

    this.$questionCommentArea = $('.ql-editor', this.$context);

    this.instantiateProgressBar();
    this.listenToCommentEditEvent();
    this.bindAll();
  }

  instantiateProgressBar() {
    const radius = this.progressCircle.getAttribute('r');
    const pcClass = 'q-progress-circle';

    this.progressCircle.style.strokeDasharray = 2 * Math.PI * radius;
    this.progressCircle.style.strokeDashoffset = 2 * Math.PI * radius;

    this.editor.on('text-change', () => {
      const currentLength = this.editor.getLength();
      const ratio = currentLength / this.maximumCharactersLength;

      if (ratio < 0.9) {
        this.progressCircle.classList.remove(`${pcClass}--warn`, `${pcClass}--danger`, `${pcClass}--pulse`);
        this.progressCircle.classList.add(`${pcClass}--safe`);
        this.$sendButton.get(0).disabled = false;
        this.charCounter.classList.remove(`${pcClass}--error`);
        this.charCounter.innerText = '';
      } else if (1 >= ratio && ratio >= 0.9) {
        this.progressCircle.classList.remove(`${pcClass}--safe`, `${pcClass}--danger`, `${pcClass}--pulse`);
        this.progressCircle.classList.add(`${pcClass}--warn`);
        this.charCounter.classList.remove(`${pcClass}--error`);
        this.charCounter.innerText = this.maximumCharactersLength - currentLength;
        this.$sendButton.get(0).disabled = false;
      } else {
        this.progressCircle.classList.remove(`${pcClass}--safe`, `${pcClass}--warn`);
        this.progressCircle.classList.add(`${pcClass}--danger`, `${pcClass}--pulse`);
        this.charCounter.classList.add('error');
        this.charCounter.innerText = this.maximumCharactersLength - currentLength;
        this.$sendButton.get(0).disabled = true;
      }

      this.progressCircle.style.strokeDashoffset =
        ratio >= 1 ? 0 : 2 * Math.PI * radius - ratio * (2 * Math.PI * radius);
    });
  }

  bindAll() {
    this.activateCreateMode();
    this.bindCancelButton();
    this.attachEvent();
  }

  bindCancelButton() {
    this.$cancelButton.off('click').on('click', () => {
      this.editor.setText('');
      this.$cancelButton.addClass('hidden');
      this.activateCreateMode();
    });
  }

  listenToCommentEditEvent() {
    EventManager.subscribe(`questionComment.${this.questionId}.populateEditor`, this.updateEditor.bind(this));

    EventManager.subscribe(`questionComment.${this.questionId}.failed`, this.updateEditor.bind(this));

    EventManager.subscribe(`questionComment.${this.questionId}.saved`, this.clearEditor.bind(this));
  }

  updateEditor(event, data) {
    this.$cancelButton.removeClass('hidden');
    this.editor.clipboard.dangerouslyPasteHTML(data.commentHTML);

    const { top, left } = this.$context.offset();

    if (top === 0 && left === 0) {
      return false;
    }

    this.activateEditMode(data.commentId);

    $('html, body').animate({ scrollTop: top - 40 }, 800);
  }

  clearEditor() {
    this.editor.setText('');
  }

  activateEditMode(commentId) {
    this.$sendButton.text('Editar');

    this.$sendButton.off('click').on('click', () => {
      if (this._validateCommentArea()) {
        EventManager.publish(`questionComment.${this.questionId}.update`, {
          commentHTML: this.$questionCommentArea.html(),
          commentId: commentId
        });

        this.$cancelButton.addClass('hidden');

        this.activateCreateMode();
      }
    });
  }

  activateCreateMode() {
    this.$sendButton.text('Responder');

    this.$sendButton.off('click').on('click', e => {
      e.preventDefault();

      if (this._validateCommentArea()) {
        EventManager.publish(`questionComment.${this.questionId}.create`, {
          commentHTML: this.$questionCommentArea.html()
        });

        EventManager.publish('followOnComment', this.questionId);
      }
    });
  }

  _validateCommentArea() {
    if ($.trim(this.$questionCommentArea.text()).length > 0) {
      return true;
    } else {
      toastr.warning('Seu comentário não pode ser vazio.');
      return false;
    }
  }

  attachEvent() {
    this.$sendButton.on('click', e => {
      e.preventDefault();

      if (this._validateCommentArea()) {
        UserTracker.emit('event', {
          eventName: 'question commentary created',
          data: {
            reply_enabled: this.replyEnabled
          }
        });
      }
    });
  }

  static createAndRender(questionId, segmentId, commentHTML) {
    return new Promise((resolve, reject) => {
      QuestionComment.createAndRender(questionId, segmentId, commentHTML)
        .then(html => {
          resolve(html);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static updateAndRender(questionId, commentId, commentHTML) {
    return new Promise((resolve, reject) => {
      QuestionComment.updateAndRender(questionId, commentId, commentHTML)
        .then(html => {
          resolve(html);
        })
        .catch(errors => {
          reject(errors);
        });
    });
  }
}
